import { injectLayoutParams } from '../layout';

// The background plugin
import background, { ModeEnum } from '@react-page/plugins-background';
// import css as well. currently, we caannot do this here in the demo project and have moved that to _app.tsx
// see https://github.com/vercel/next.js/issues/19717
import '@react-page/plugins-background/lib/index.css';

// The divider plugin
import divider from '@react-page/plugins-divider';
import '@react-page/plugins-divider/lib/index.css';

// The html5-video plugin
import '@react-page/plugins-html5-video/lib/index.css';

// The image plugin
import { imagePlugin } from '@kehila/react-page-plugins-image';
import '@kehila/react-page-plugins-image/lib/index.css';

// carousel
import carousel from './carousel';
import 'react-responsive-carousel/lib/styles/carousel.min.css'; // requires a loader
// The spacer plugin
import spacer from '@react-page/plugins-spacer';
import '@react-page/plugins-spacer/lib/index.css';

// The video plugin
import YTvideo from '@react-page/plugins-video';
import '@react-page/plugins-video/lib/index.css';
import { API_BASE_URL, ASSET_BASE_URL } from '../../../../configs/AppConfig';


// CUSTOM
import quill from './quill';
import './quill/style.css';

import block from './block';
import iframe from './iframe';
import video from './video';

import pdf from './pdf';
import '@react-pdf-viewer/core/lib/styles/index.css';
import accordion from './accordion';

const uploadService = (file, reportProgress) => {
    return new Promise(async (resolve, reject) => {
        console.log(file)

        const formData = new FormData();
        formData.append('file', file);

        const req = await fetch(API_BASE_URL + "/upload/image?autoValide=1", {
            method: "POST",
            body: formData,
            headers: {"Authorization": localStorage.getItem("AUTH_TOKEN")}
        })

        if (req.status != 200) {
            reject("UNABLE TO UPLOAD IMAGE " + file)
        }

        var fileName = await req.text()

        var url = ASSET_BASE_URL + "/" + fileName

        resolve({url: url});

    })
}

// Define which plugins we want to use.

export const cellPlugins = injectLayoutParams([
    {hideInMenu: true, id: 'null'},
    //customizedSlate,
    //{...defaultSlate,title:"Texte (Ancienne version)",hideInMenu: true},
    {
        ...background({
            imageUpload: uploadService,
            enabledModes:
                ModeEnum.COLOR_MODE_FLAG |
                ModeEnum.IMAGE_MODE_FLAG |
                ModeEnum.GRADIENT_MODE_FLAG,
        }), ...{hideInMenu: true, title: "Arriere Plan (Ancienne version)"}
    },

    block,
    quill,
    spacer,
    imagePlugin({imageUpload: uploadService}),
    carousel,
    accordion,
    YTvideo,
    divider,
    video,
    pdf,
    iframe,

])
